__turbopack_context__.v({
  "applePayButton": "YsjY-G_applePayButton",
  "label": "YsjY-G_label",
  "logo": "YsjY-G_logo",
  "logoSlot": "YsjY-G_logoSlot",
});
